module.exports = __webpack_public_path__ + "img/01_SPHERES-SOLID.f16649bd.gif";